import React, { useEffect, useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { joinWaitlist } from "@/lib/api";

export default function StickyBar() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const doc = document.documentElement.scrollHeight - window.innerHeight;
      const waitlist = document.getElementById("waitlist");
      const inWaitlist = waitlist && waitlist.getBoundingClientRect().top < window.innerHeight;
      setVisible(y > 900 && !inWaitlist && y < doc - 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!valid) return;
    setLoading(true);
    try {
      const res = await joinWaitlist(email.trim(), "sticky-bar");
      setDone(true);
      toast.success(`You're #${res.position}. Welcome.`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Try again.");
    } finally { setLoading(false); }
  };

  if (!visible) return null;
  return (
    <div data-testid="sticky-bar"
      className="hidden md:block fixed bottom-4 left-1/2 -translate-x-1/2 z-[90] ds-fade-up">
      <div className="ds-crosshair relative flex items-center gap-4 bg-[#0a0a0a]/95 backdrop-blur-md border border-neutral-800 px-5 py-3">
        <span className="ds-ch-bl" /><span className="ds-ch-br" />
        <span className="w-1.5 h-1.5 bg-[#FF5000] ds-pulse" />
        <span className="text-[12px] uppercase tracking-[0.22em] text-neutral-300 whitespace-nowrap">
          {done ? "You're in. Check your inbox soon." : "Join the Community"}
        </span>
        {!done && (
          <form onSubmit={submit} className="flex items-center gap-2">
            <input data-testid="sticky-email" type="email" required placeholder="you@company.com"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-[#070707] border border-neutral-800 focus:border-[#FF5000] text-white text-[13px] px-3 py-2 outline-none placeholder:text-neutral-600 w-56" />
            <button data-testid="sticky-submit" data-cta="true" type="submit" disabled={loading || !valid}
              className="inline-flex items-center gap-1.5 bg-[#FF5000] hover:bg-[#FF7333] disabled:bg-neutral-800 text-white text-[12px] font-medium px-3 py-2 transition-colors">
              {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <>Request <ArrowRight className="w-3.5 h-3.5" /></>}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
